/*
==========================================================
IMPORTS
==========================================================
*/

import AuthLayout from "../../../components/platform/auth/AuthLayout/AuthLayout";

import RegisterForm from "../../../components/platform/auth/RegisterForm/RegisterForm";

/*
==========================================================
PAGE
==========================================================
*/

export default function RegisterPage() {

  return (

    <AuthLayout>

      <RegisterForm />

    </AuthLayout>

  );

}